import Icon from '../../../components/AppIcon';

interface RoleSelectorProps {
  selectedRole: 'admin' | 'member';
  onRoleChange: (role: 'admin' | 'member') => void;
  error?: string;
}

const RoleSelector = ({ selectedRole, onRoleChange, error }: RoleSelectorProps) => {
  const roles = [
    {
      value: 'admin' as const,
      label: 'Create a Group',
      description: 'Subscribe to a plan and start managing your own community group',
      icon: 'Users',
    },
    {
      value: 'member' as const,
      label: 'Join a Group',
      description: 'Participate in existing community groups',
      icon: 'UserPlus',
    },
  ];

  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-foreground">
        I want to <span className="text-destructive">*</span>
      </label>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {roles.map((role) => (
          <button
            key={role.value}
            type="button"
            onClick={() => onRoleChange(role.value)}
            className={`
              relative p-4 rounded-md border-2 transition-all
              ${
                selectedRole === role.value
                  ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/50'
              }
            `}
          >
            <div className="flex items-start gap-3">
              <div
                className={`
                w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0
                ${
                  selectedRole === role.value
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-muted-foreground'
                }
              `}
              >
                <Icon name={role.icon} size={20} />
              </div>
              <div className="flex-1 text-left">
                <div className="font-medium text-foreground mb-1">{role.label}</div>
                <div className="text-xs text-muted-foreground">{role.description}</div>
              </div>
              {selectedRole === role.value && (
                <div className="absolute top-3 right-3">
                  <Icon name="CheckCircle2" size={20} color="var(--color-primary)" />
                </div>
              )}
            </div>
          </button>
        ))}
      </div>

      {error && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};

export default RoleSelector;